// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".send-referral-form__inputs .service-type-section{margin-top:5px}.send-referral-form__inputs .display-field{margin-bottom:34px}.send-referral-form__inputs .display-field__label{font-weight:bold}.send-referral-form__actions{display:flex;justify-content:flex-end}.send-referral-form__action-item{flex:0 1 auto}.send-referral-form .consent-reminder{margin:auto auto 40px}", ""]);
// Exports
module.exports = exports;
